import React from 'react'
import Menu from '../Menu/Menu'
import Social from '../Social/Social'
import "./Sidebar.scss"
import { motion } from "framer-motion"

const Sidebar = () => {
  return (
    <motion.div
    initial={{ x: -100 }}
    animate={{ x: 0 }} 
    transition={{ duration: 0.6, ease: 'easeOut' }}
    className="sidebar"
  >
    <div className='sidebar container'>
        <div className="menu-container">
            <Menu closeMenu={null} />
        </div>
        <div className="social">
            <Social />
        </div>
    </div>
    </motion.div>
  )
}

export default Sidebar